;(() => {
	/************************************************************************************

  * [START: OLD CUSTOMIZE CODE]

  *************************************************************************************/

	const shopMenuLink = document.querySelector('.shopMenuLink')
	if (shopMenuLink) {
		shopMenuLink.addEventListener('click', (e) => {
			e.preventDefault()
			shopMenuLink.parentElement.classList.toggle('isOpen')
		})
	}

	window.customThemeVariables = {
		limitedEditionLabelHandler: function limitedEditionLabelHandler(newContent) {
			try {
				newContent.querySelectorAll('.variant-picker__option').forEach((variantPicker) => {
					let variantName = ''
					if (!variantPicker.querySelector('.limited-edition__custom')) return
					if (
						variantPicker.querySelector('input:checked') &&
						variantPicker.querySelector('input:checked').closest('.limited-edition__custom')
					) {
						variantName = variantPicker.querySelector('.variant-picker__option-info span').innerText
						variantPicker.querySelector('.variant-picker__option-info span').innerText = ''
						variantPicker.querySelector('.limited-edition__custom__option-info span').innerText = variantName
					} else {
						variantPicker.querySelector('.limited-edition__custom__option-info span').innerText = ''
					}
				})
			} catch (error) {
				console.error('Something went wrong while handling Limited Edition Label Change:', error)
			}
		},
	}

	class ImageSlider {
		constructor(slider) {
			this.slider = slider
			this.slides = Array.from(slider.querySelectorAll('.images-section > .flex'))
			this.paginationContainer = slider.querySelector('.paginationCustom')
			this.paginationDots = []

			this.init()
		}

		init() {
			this.renderPaginationDots()
			this.activateDot()

			// Event Listener for scroll end
			this.slider.querySelector('.images-section').addEventListener('scrollend', () => {
				this.activateDot()
			})
		}

		renderPaginationDots() {
			if (!this.paginationContainer) return

			this.paginationContainer.innerHTML = '' // Clear existing dots (if any)
			this.slides.forEach(() => {
				const dot = document.createElement('div')
				dot.classList.add('pagination-dot')
				this.paginationContainer.appendChild(dot)
				this.paginationDots.push(dot)
			})
		}

		activateDot() {
			let activeIndex = this.getActiveSlideIndex()

			this.paginationDots.forEach((dot, index) => {
				dot.classList.toggle('active', index === activeIndex)
			})
		}

		getActiveSlideIndex() {
			let activeIndex
			this.slides.forEach((slide, index) => {
				if (Math.abs(slide.getBoundingClientRect().left - this.slider.getBoundingClientRect().left) <= 10) {
					activeIndex = index
				}
			})

			return activeIndex !== undefined ? activeIndex : this.slides.length - 1
		}
	}

	document.querySelectorAll('.images-show-section--slider').forEach((slider) => new ImageSlider(slider))

	window.customThemeVariables.limitedEditionLabelHandler(document)

	/**** Change Upsell Products' Images ****/
	const addImageChangeEventListener = function () {
		try {
			document.querySelectorAll('.cart-drawer__recommendations .horizontal-product').forEach((upsellProduct) => {
				upsellProduct.querySelector('select[name="id"]').addEventListener('change', (e) => {
					// Remove Errors:
					upsellProduct.querySelectorAll('.upsell-error').forEach((el) => el.remove())
					const newValue = e.target.value
					upsellProduct.querySelectorAll('.quickAddImagesContainer .quick-variant-image').forEach((variant) => {
						if (variant.getAttribute('data-variant-id') == newValue) {
							variant.classList.remove('hidden')
						} else {
							variant.classList.add('hidden')
						}
					})
				})
			})
		} catch (error) {
			console.error('Something went wrong while setting upsell product event listeners:', error)
		}
	}

	addImageChangeEventListener()

	window.customThemeVariables.addImageChangeEventListener = addImageChangeEventListener
	/**** Change Upsell Products' Images End****/

	/************************************************************************************

  * [END: OLD CUSTOMIZE CODE]

  *************************************************************************************/
})()

/************************************************************************************

* GENERAL FUNCTIONALITIES

*************************************************************************************/

function l_getFocusableElements(container) {
	return Array.from(
		container.querySelectorAll(
			"summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
		)
	).filter((element) => !element.closest('[aria-hidden="true"]'))
}

function l_disableFocusableElements(container) {
	const focusableElements = l_getFocusableElements(container)
	focusableElements.forEach((element) => {
		element.setAttribute('tabindex', '-1')
		element.setAttribute('aria-disabled', 'true')
	})
}

function l_enableFocusableElements(container) {
	const focusableElements = l_getFocusableElements(container)

	focusableElements.forEach((element) => {
		element.removeAttribute('tabindex')
		element.removeAttribute('aria-disabled')
	})
}

function l_addEventDelegate({
	context = document.documentElement,
	event = 'click',
	selector,
	handler,
	capture = false,
}) {
	const listener = function (e) {
		// loop parent nodes from the target to the delegation node
		for (let target = e.target; target && target !== this; target = target.parentNode) {
			if (target.matches(selector)) {
				handler.call(target, e, target)
				break
			}
		}
	}
	context.addEventListener(event, listener, capture)
	return () => {
		context.removeEventListener(event, listener, capture)
	}
}

function l_debounce(fn, wait) {
	let t

	return (...args) => {
		clearTimeout(t)
		t = setTimeout(() => fn.apply(this, args), wait)
	}
}

function l_pauseAllMedia(container = document) {
	container.querySelectorAll('l-external-media').forEach((video) => {
		video?.pauseVideo?.()
	})
	container.querySelectorAll('.js-youtube').forEach((youtubeVideo) => {
		youtubeVideo.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
	})
	container.querySelectorAll('.js-vimeo').forEach((vimeoVideo) => {
		vimeoVideo.contentWindow.postMessage('{"method":"pause"}', '*')
	})
	container.querySelectorAll('video').forEach((video) => video.pause())
	container.querySelectorAll('product-model').forEach((model) => {
		if (model.modelViewerUI) model.modelViewerUI.pause()
	})
	container.querySelectorAll('video').forEach((video) => {
		video.pause()
	})
}

function l_playMedia(container = document) {
	container.querySelectorAll('l-external-media').forEach((video) => {
		video?.playVideo?.()
	})
	container.querySelectorAll('.js-youtube').forEach((youtubeVideo) => {
		youtubeVideo.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*')
	})
	container.querySelectorAll('.js-vimeo').forEach((vimeoVideo) => {
		vimeoVideo.contentWindow.postMessage('{"method":"play"}', '*')
	})
	container.querySelectorAll('product-model').forEach((model) => {
		if (model.modelViewerUI) model.modelViewerUI.play()
	})
	container.querySelectorAll('video').forEach((video) => {
		video.play()
	})
}

/************************************************************************************

* GENERAL COMPONENTS / FEATURES

*************************************************************************************/

if (!customElements.get('l-swiper-carousel')) {
	customElements.define(
		'l-swiper-carousel',
		class LTASwiperCarousel extends HTMLElement {
			constructor() {
				super()
			}

			connectedCallback() {
				// Check if Swiper is already loaded
				if (window.Swiper) {
					this.setupCarousel()

					return
				}

				document.addEventListener('l:vendor:loaded', () => {
					this.setupCarousel()
				})
			}

			setupCarousel() {
				this.carouselConfig = JSON.parse(this.querySelector('[data-carousel-config]').textContent)

				if (!this.carouselConfig) return

				this.swiperSlideEls = this.querySelectorAll('.swiper-slide')

				this.classList.remove('is-placeholder')
				this.swiperSlideEls.forEach((swiperSlide) => swiperSlide.classList.remove('l-hidden'))

				this.swiperCarousel = new window.Swiper(this, this.carouselConfig)

				Shopify.designMode && this.designModeScroll()
			}

			designModeScroll() {
				document.addEventListener('shopify:block:select', (event) => {
					const targetEl = event.target

					this.swiperSlideEls.forEach((swiperSlide, index0) => {
						if (targetEl == swiperSlide) this.slideTo(index0)
					})
				})
			}

			slideTo(index = 0) {
				this.swiperCarousel.slideTo(index)
			}
		}
	)
}

if (!customElements.get('l-collapsible-tab')) {
	customElements.define(
		'l-collapsible-tab',
		class LTACollapsibleTab extends HTMLElement {
			constructor() {
				super()
			}

			connectedCallback() {
				// Elements
				this.trigger = this.querySelector('[data-trigger]')
				this.content = this.querySelector('[data-content]')

				// Data
				this.expandedClass = 'is-expanded'
				this.collapsedClass = 'is-collapsed'
				this.collapsedHeight = '0px'
				this.oneAtATime = true

				this.transitionendEvent = this.transitionendEventName()

				// Setup default behavior / data
				this.dataset.oneOpen === 'false' && (this.oneAtATime = false)

				if (this.getAttribute('open') === 'true') {
					this.selected = true
					this.classList.add(this.expandedClass)
					this.setExpandedAria()
				} else {
					this.content.style.height = this.collapsedHeight
					this.classList.add(this.collapsedClass)
					this.setCollapsedAria()
					l_disableFocusableElements(this.content)
				}

				this.content.removeAttribute('hidden')

				// Events
				this.trigger.addEventListener('click', (e) => this.toggle(e))
			}

			toggle(e) {
				e.preventDefault()

				this.selected ? this.close() : this.open()

				/* Close another tab and open only the current tab. */
				if (this.selected && this.oneAtATime) {
					const tabsContainer = this.closest('[data-collapsible-wrapper]')
					const collapsibleTabs = tabsContainer?.querySelectorAll('l-collapsible-tab')

					collapsibleTabs?.length &&
						collapsibleTabs.forEach((tab) => {
							tab !== this && tab.selected && tabsContainer !== tab && tab.close()
						})
				}
			}

			open() {
				this.selected = true
				this.expand()
				this.setAttribute('open', true)
				l_enableFocusableElements(this.content)
			}

			close() {
				this.selected = false
				this.collapse()
				this.removeAttribute('open')
				l_disableFocusableElements(this.content)
			}

			expand() {
				const onTransitionEnd = ((event) => {
					if (event.target === this.content) {
						this.content.removeEventListener(this.transitionendEvent, onTransitionEnd)

						this.isOpen &&
							requestAnimationFrame(() => {
								this.content.style.transition = '0'
								this.content.style.height = 'auto'

								requestAnimationFrame(() => {
									this.content.style.height = null
									this.content.style.transition = null
									this.setExpandedAria()
								})
							})
					}
				}).bind(this)

				this.content.addEventListener(this.transitionendEvent, onTransitionEnd)
				this.isOpen = true
				this.classList.add(this.expandedClass)
				this.classList.remove(this.collapsedClass)
				this.content.style.height = this.content.scrollHeight + 'px'
			}

			collapse() {
				const onTransitionEnd = ((event) => {
					if (event.target === this.content) {
						this.content.removeEventListener(this.transitionendEvent, onTransitionEnd)

						if (!this.isOpen) {
							this.setCollapsedAria()
							this.classList.add(this.collapsedClass)
						}
					}
				}).bind(this)

				this.content.addEventListener(this.transitionendEvent, onTransitionEnd)
				this.isOpen = false
				this.classList.remove(this.expandedClass)

				requestAnimationFrame(() => {
					this.content.style.transition = '0'
					this.content.style.height = this.content.scrollHeight + 'px'

					requestAnimationFrame(() => {
						this.content.style.transition = null
						this.content.style.height = this.collapsedHeight
					})
				})
			}

			destroy() {
				this.trigger && this.trigger.removeEventListener('click', (e) => this.toggle(e))
				this.content && this.content.removeAttribute('aria-hidden')
				this.content && (this.content.style.height = 'auto')

				this.classList.remove(this.expandedClass, this.collapsedClass)
				this.removeAttribute('open')
			}

			transitionendEventName() {
				let eventName,
					testElement = document.createElement('div'),
					eventNames = {
						transition: 'transitionend',
						OTransition: 'otransitionend',
						MozTransition: 'transitionend',
						WebkitTransition: 'webkitTransitionEnd',
					}

				for (eventName in eventNames) {
					if (eventNames.hasOwnProperty(eventName) && testElement.style[eventName] !== false) {
						return eventNames[eventName]
					}
				}
			}

			setExpandedAria() {
				this.trigger.setAttribute('aria-expanded', 'true')
				this.content.removeAttribute('aria-hidden')
				this.content.removeAttribute('tabindex')
			}

			setCollapsedAria() {
				this.trigger.setAttribute('aria-expanded', 'false')
				this.content.setAttribute('aria-hidden', 'true')
				this.content.setAttribute('tabindex', '-1')
			}
		}
	)
}

if (!customElements.get('l-customer-reviews')) {
	customElements.define(
		'l-customer-reviews',
		class LTACustomerReviews extends HTMLElement {
			constructor() {
				super()
			}

			connectedCallback() {
				// Elements
				this.showMoreLessBtnEl = this.querySelector('[data-show-more-less]')
				this.reviewCardEls = this.querySelectorAll('.js-review-card')

				// Events
				if (this.showMoreLessBtnEl) {
					this.showMoreLessBtnEl.addEventListener('click', (e) => {
						e.preventDefault()

						const isOpen = this.showMoreLessBtnEl.classList.contains('is-open')
						this.showMoreLessBtnEl.classList.toggle('is-open')

						this.reviewCardEls.forEach((reviewCardEl, index0) => {
							if (isOpen) {
								reviewCardEl.classList.toggle('l-hidden', index0 > 2)
							} else {
								reviewCardEl.classList.remove('l-hidden')
							}
						})
					})
				}
			}
		}
	)
}

class LTAMediaVideo extends HTMLElement {
	constructor() {
		super()
	}

	connectedCallback() {
		// Elements
		this.videoContainerEl = this.querySelector('[data-video-container]') || this

		// Click
		this.addEventListener('click', (event) => {
			const hasLoaded = this.classList.contains('is-loaded')
			const isPlaying = this.classList.contains('is-playing')

			hasLoaded ? (isPlaying ? this.pauseVideo() : this.playVideo()) : this.initPlayer(event)
		})
	}

	initPlayer(event) {
		event.preventDefault()

		const templateEl = this.querySelector('template')

		if (!templateEl) return

		this.pauseOtherVideos()

		// Add template content to the element
		const templateContentEl = templateEl.content.cloneNode(true)

		this.videoContainerEl.appendChild(templateContentEl)
		this.classList.add('is-loaded', 'is-playing')
	}

	playVideo() {
		this.pauseOtherVideos()
		l_playMedia(this)

		this.classList.add('is-playing')
		this.classList.remove('is-paused')
	}

	pauseVideo() {
		l_pauseAllMedia(this)

		this.classList.remove('is-playing')
		this.classList.add('is-paused')
	}

	pauseOtherVideos() {
		l_pauseAllMedia(this.parentElement)

		this.parentElement.querySelectorAll('l-media-video').forEach((videoEl) => {
			const isLoaded = videoEl.classList.contains('is-loaded')

			if (isLoaded) {
				videoEl.classList.remove('is-playing')
				videoEl.classList.add('is-paused')
			}
		})
	}
}

customElements.define('l-media-video', LTAMediaVideo)

if (!customElements.get('l-sound-quality')) {
	class LTASoundQuality extends HTMLElement {
		static currentPlayingAudio = null

		constructor() {
			super()

			this.toggleButtonEl = null
			this.audioEls = []
			this.audioButtonEls = []
			this._wasPlayingBeforeOut = false
			this._intersectionObserver = null
			this._isInViewport = true // Assume visible on load
		}

		connectedCallback() {
			this.toggleButtonEl = this.querySelector('[data-toggle-button]')
			this.audioEls = Array.from(this.querySelectorAll('[data-audio]'))
			this.audioButtonEls = Array.from(this.querySelectorAll('[data-audio-button]'))
			this.currentPlayingAudio = this.audioEls[0] || null

			this._addEventListeners()
			this._setupAudioEndedHandlers()
			this._setupViewportObserver()
		}

		disconnectedCallback() {
			if (this._intersectionObserver) {
				this._intersectionObserver.disconnect()
				this._intersectionObserver = null
			}
		}

		_addEventListeners() {
			this.audioButtonEls.forEach((btn, idx) => {
				btn.addEventListener('click', (event) => this._handleAudioButton(event, idx))
			})
			if (this.toggleButtonEl) {
				this.toggleButtonEl.addEventListener('click', (event) => this._handleToggleButton(event))
			}
		}

		_setupAudioEndedHandlers() {
			this.audioEls.forEach((audio) => {
				audio.addEventListener('ended', () => {
					if (audio === this.currentPlayingAudio) {
						audio.currentTime = 0
						this.currentPlayingAudio = this.audioEls[0]
						if (this.toggleButtonEl && this.toggleButtonEl.classList.contains('is-active') && this._isInViewport) {
							audio.play()
							this.currentPlayingAudio = audio
						}
					}
				})
			})
		}

		_setupViewportObserver() {
			if (typeof IntersectionObserver === 'undefined') return
			this._intersectionObserver = new IntersectionObserver(
				(entries) => {
					for (const entry of entries) {
						if (entry.target === this) {
							entry.isIntersecting ? this._onEnteredViewport() : this._onLeftViewport()
						}
					}
				},
				{
					root: null,
					threshold: 0.15,
				}
			)
			this._intersectionObserver.observe(this)
		}

		_onEnteredViewport() {
			this._isInViewport = true
			if (
				this.toggleButtonEl?.classList.contains('is-active') &&
				this._wasPlayingBeforeOut &&
				this.currentPlayingAudio &&
				this.currentPlayingAudio.paused
			) {
				this.currentPlayingAudio.play()
				this._wasPlayingBeforeOut = false
			}
		}

		_onLeftViewport() {
			this._isInViewport = false
			if (
				this.toggleButtonEl?.classList.contains('is-active') &&
				this.currentPlayingAudio &&
				!this.currentPlayingAudio.paused
			) {
				this.currentPlayingAudio.pause()
				this._wasPlayingBeforeOut = true
			}
		}

		_handleToggleButton(e) {
			e.preventDefault()
			const isActive = this.toggleButtonEl.classList.toggle('is-active')
			let currentAudio =
				this.currentPlayingAudio || this.audioEls.find((a) => !a.paused && !a.ended && a.currentTime > 0)

			if (currentAudio && currentAudio.ended) currentAudio.currentTime = 0
			if (!currentAudio) return

			if (isActive) {
				if (this._isInViewport) {
					currentAudio.play()
				}
				this.currentPlayingAudio = currentAudio
			} else {
				currentAudio.pause()
				this.currentPlayingAudio = currentAudio
				this._wasPlayingBeforeOut = false
			}
			this._setActiveButton(this.audioEls.indexOf(currentAudio))
		}

		_handleAudioButton(e, idx) {
			e.preventDefault()
			const time = this._getCurrentAudioTime()
			this._setActiveButton(idx)
			this._playAudioAtIndex(idx, time)
		}

		_getCurrentAudioTime() {
			const audio = this.audioEls.find((a) => !a.paused && !a.ended && a.currentTime > 0)
			return audio ? audio.currentTime : 0
		}

		_setActiveButton(activeIdx) {
			this.audioButtonEls.forEach((btn, idx) => {
				btn.classList.toggle('is-active', idx === activeIdx)
			})
		}

		_playAudioAtIndex(idx, time) {
			this.audioEls.forEach((audio, i) => {
				if (i === idx) {
					if (!isNaN(time)) {
						try {
							audio.currentTime = time
						} catch {}
					}
					if (this.toggleButtonEl?.classList.contains('is-active') && this._isInViewport) {
						audio.play()
					}
					this.currentPlayingAudio = audio
				} else {
					audio.pause()
				}
			})
		}
	}

	customElements.define('l-sound-quality', LTASoundQuality)
}

function l_openKlaviyForm(formId) {
	window._klOnsite = window._klOnsite || []
	window._klOnsite.push(['openForm', formId])
}

document.addEventListener('DOMContentLoaded', () => {
	const registerFormLinkEls = document.querySelectorAll('a[href="#register-form"]')
	registerFormLinkEls.forEach((registerFormLinkEl) => {
		registerFormLinkEl.addEventListener('click', (event) => {
			event.preventDefault()

			l_openKlaviyForm('T8eHKJ')
		})
	})
})

